@let palette = pallet();

<div class="flex flex-col px-3 sm:px-0">
  <div class="flex flex-row gap-2 w-full soft-card rounded p-2 items-center mt-2">
    <soft-icon name="fa-regular text-lg fa-pallet-boxes"></soft-icon>
    <div class="flex flex-col">
      @if (palette?.extref | isDefinedNotEmpty) {
        <span class="text-sm soft-overline">{{ palette?.extref }}</span>
      }

      <span class="text-lg font-semibold">{{ palette?.sscc }}</span>

      @if (!!palette?.menge) {
        <span class="text-sm text-light"
          >{{ palette?.menge }} {{ palette?.einheit?.arteh }}</span
        >
      }

      @if (
        !!palette?.lagerplatz && (palette?.lagerplatz?.lagerplatz | isDefinedNotEmpty)
      ) {
        <span class="text-sm text-light">{{ palette?.lagerplatz?.lagerplatz }}</span>
      }
    </div>
  </div>

  @if (items(); as items) {
    <div class="mt-2 mb-3 pb-2 sm:mb-0 sm:pb-1 max-h-[55vh] overflow-y-auto">
      <div class="soft-overline">Artikel</div>
      @for (item of items ?? []; track item.artikel.id) {
        <div
          class="flex flex-row justify-between flex-nowrap pr-1"
          [class.pt-2]="!$first"
          [class.pb-2]="!$last"
          [class.border-b]="!$last"
        >
          <div class="grid grid-cols-[32px_1fr] gap-2.5">
            <div
              class="p-1 font-semibold text-sm rounded flex flex-row items-center justify-center text-center border border-primary text-primary aspect-square"
            >
              {{ $index + 1 }}
            </div>

            <div class="flex flex-col">
              <span class="text-sm color-light">{{ item.artikel.nummer }}</span>
              <span class="font-semibold">{{ item.artikel.artbez1 }}</span>
              <span class="text-sm text-light">{{ item.artikel?.artbez2 }}</span>
              <span class="text-sm text-light">{{ item.artikel?.artbez3 }}</span>
              <span class="text-sm text-light">{{ item.artikel?.artbez4 }}</span>
              <span class="text-sm text-light">{{ item.artikel?.artbez5 }}</span>
              @if (item.artikel?.beschreibung | isDefinedNotEmpty) {
                <span
                  class="text-sm text-light"
                  [innerText]="item.artikel?.beschreibung"
                ></span>
              }
            </div>
          </div>

          <div class="flex flex-col justify-start items-end">
            <div
              class="flex flex-row flex-nowrap text-light font-semibold items-center text-base"
            >
              <span>{{ item.menge }}</span>
              <span class="ml-1">{{ item.einheit.arteh }}</span>
            </div>

            @if (item.einheit.id !== item.einheit_lg.id) {
              <div class="flex flex-row flex-nowrap color-light items-center text-xl">
                <span class="whitespace-nowrap">= {{ item.menge_lg }}</span>
                <span class="ml-1">{{ item.einheit_lg.arteh }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
